import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@app/shared/api.service';

@Component({
  selector: 'app-user-selection',
  templateUrl: './user-selection.component.html',
  styleUrls: ['./user-selection.component.scss'],
})
export class UserSelectionComponent implements OnInit {
  /** The state received from the login page */
  state: any;

  constructor(
    private readonly activatedroute: ActivatedRoute,
    private readonly router: Router,
    private readonly apiService: ApiService
  ) {
    // Works only in constructor
    this.state = this.router.getCurrentNavigation().extras.state;

    // Uncomment when committing
    // Navigates to login page when refreshing/if no state parameter is present
    if (!this.state) {
      this.router.navigate(['login']);
    }
  }

  ngOnInit() {
    this.activatedroute.data.subscribe((data) => {
      console.log({ data });
    });
  }

  /**
   * Posts the data of the selected entity and redirects the successfully logged in user
   *
   * @param selectedEntityNumber
   */
  postSelectEntity(selectedEntityNumber: any) {
    this.apiService.postSelectEntity(this.state.userInfos[selectedEntityNumber], this.state.signId).subscribe(
      (data: any) => {
        this.redirectTo(data.redirectUrl);
      },
      (error: any) => {
        // show general error
        this.router.navigate(['login']);
      }
    );
  }

  /**
   * The redirect to method.
   *
   * @param url The url identifier.
   */
  redirectTo(url: string): void {
    window.location.href = url;
  }
}
